<template>
    <Card>
        <div>
            <div class="sousuo" style="width: 100%">
                <div style="width: 350px" class="yl-flex flex_between">
                    <Input placeholder="搜索媒体名称" v-model="name" style="width: 250px">
                        <i-button slot="append" icon="ios-search"></i-button>
                    </Input>
                    <Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
                </div>
            </div>
            <div class="multiple">
                <div class="child-div">申请时间</div>
                <RadioGroup v-model="timePeriod">
                    <Radio label="0"><span>不限</span></Radio>
                    <Radio label="1"><span>今日</span></Radio>
                    <Radio label="2"><span>昨日</span></Radio>
                    <Radio label="3"><span>本周</span></Radio>
                    <Radio label="4"><span>上周</span></Radio>
                    <Radio label="5"><span>本月</span></Radio>
                    <Radio label="6"><span>上月</span></Radio>
                    <Radio label="7"><span>自定义</span></Radio>
                    <DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
                                placeholder="选择日期" style="width: 200px"></DatePicker>

                </RadioGroup>
            </div>
            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">
                    <template slot-scope="{ row }" slot="operation">
                        <div>
                            <div v-if="row.status == -1" style="display: flex; justify-content: space-between; align-items: center;">
                                <span style="color: #63B3E6; cursor: pointer;" @click.stop="pass" :data-id="row.id">已打款</span>
                                <span style="color: red; cursor: pointer;" @click.stop="refuse" :data-id="row.id">拒绝</span>
                            </div>
                            <div>--</div>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="pager">
                <Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-elevator/>
            </div>

        </div>
    </Card>
</template>
<script>
    import {mapGetters} from "vuex";
    import {getMediaWithdrawList, withdrawUpdate} from "../../api/runSet"


    export default {
        name: "mediaPlatformWithdraw",
        components: {},

        data() {
            return {
                name: '',
                count: 0,
                page: 1,
                timePeriod: '0',
                timePeriodDate: '',
                datas: [ ],
                columns: [
                    {
                        "title": "id",
                        "key": "id",
                        width: 50,
                        align: 'center'
                    },
                    {
                        "title": "媒体名称",
                        "key": "medium_name",
                        width: 150,
                        align: 'center'
                    },
                    {
                        "title": "提现金额",
                        "key": "money",
                        width: 150,
                        align: 'center'
                    },
                    {
                        "title": "提现支付宝姓名",
                        "key": "realname",
                        "width": 250
                    },
                    {
                        "title": "提现支付宝账号",
                        "key": "account",
                        "width": 250
                    },
                    {
                        "title": "申请时间",
                        "key": "created_at",
                        "width": 250,
                        "sortable": true
                    },
                    {
                        "title": "状态",
                        "key": "status_name",
                        align: 'center'
                    },
                    {
                        "title": "操作",
                        "slot": "operation",
                        align: 'center',
                        "width": 80
                    }
                ],
            }
        },
        computed: {
            ...mapGetters(['token', 'userInfo'])
        },
        mounted() {
            this.getList();
        },
        methods: {

            timePeriodDateChange(e) {
                this.timePeriodDate = e
            },
            async getList() {
                let that = this;
                let data = {
                    token: that.token,
                    timePeriod: that.timePeriod,
                    timePeriodDate: that.timePeriodDate,
                    name: that.name
                };
                let res = await getMediaWithdrawList(that, data);
                if (res.code == 1) {
                    that.datas = res.data.list;
                    that.count = res.count;
                }
            },
            search() {
                this.page = 1;
                this.getList();
            },
            changePage(e) {
                this.page = e;
                this.getList()
            },
            // 提现
            pass(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                that.$Modal.confirm({
                    title: '确认已打款吗？',
                    onOk: async() => {
                        that.throttle(async function () {
                            let data = {token: that.token, id:id, status: 1}
                            let res = await withdrawUpdate(that, data);
                            if (res.code == 1) {
                                that.$Message.success(res.msg);
                            }
                            that.getList();
                        }, 500)
                    }
                })
            },
            refuse(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                that.$Modal.confirm({
                    title: '确认拒绝吗？',
                    onOk: async() => {
                        that.throttle(async function () {
                            let data = {token: that.token, id:id, status: -2}
                            let res = await withdrawUpdate(that, data);
                            if (res.code == 1) {
                                that.$Message.success(res.msg);
                            }
                            that.getList();
                        }, 500)
                    }
                })
            }
        },


    }
</script>
<style scoped lang="less">

    .yellow_btn {
        color: #F8BD66;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }


    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .flex_between p{
        display: inline-block;
    }
</style>
